import React from "react";
import Configuration from "./services/context";

const App = () => {
  return <Configuration />;
};

export default App;
